export default "__VITE_ASSET__a5039ed1__"